<template>
  <VeeField
    v-if="useCartFormData().value.invoiceAddress != null"
    v-slot="{ field, meta, errors }"
    v-model="useCartFormData().value.invoiceAddress!.country"
    name="country"
    rules="required"
  >
    <div :class="meta.touched ? (meta.valid ? 'valid' : 'invalid') : ''">
      <input
        v-bind="field"
        disabled
        class="inp sm bg-[#e4e4e4] cursor-not-allowed"
        type="text"
        placeholder="Land.*"
      >
    </div>
    <span>{{ errors[0] }}</span>
  </VeeField>
</template>
<script lang="ts" setup>
import { useCartFormData } from "~/composables/states";
</script>
